import styled from 'styled-components';
import { device } from '../../theme';

export const DescriptionContainer = styled.div`
  @media ${device.medium} {
    margin-bottom: 32px;
  }
`;
